import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { ParkSessionStatus } from "ipctg-inflow-types/InFlowEnums"

import api from "@/utilities/api"

import { log } from "@/utilities/logging"

export const Route = createFileRoute(
  "/qr/$qrLookupID/passes/$epoch/redeem/$passID"
)({
  beforeLoad: async ({ context, params, matches }) => {
    if (!context.isAuthenticated) {
      log({
        level: "warn",
        flow: "passes:redeem",
        scope: "guard.auth",
        message: "User is unauthenticated, redirecting to /sign-in",
        meta: { isAuthenticated: context.isAuthenticated },
      })

      // Use TanStack Router's location.href (path) instead of browser's location.href (full URL)
      throw redirect({
        to: "/auth/sign-in",
        search: {
          qrLookupID: params.qrLookupID,
          redirect: undefined,
          phone: undefined,
          plate: undefined,
          conversionFlow: undefined,
          email: undefined,
        },
      })
    }

    // Check if purchase session is already complete
    const sessionState = await api.park.sessionStatus.POST({})
    const isRedemingPass = matches.find(
      (m) => m.routeId === "/qr/$qrLookupID/passes/$epoch/redeem/$passID/"
    )

    if (sessionState.status === ParkSessionStatus.Complete && isRedemingPass) {
      log({
        level: "warn",
        flow: "passes:redeem",
        scope: "guard.sessionState",
        message:
          "Session is already complete, redirecting to /redemption-complete",
        meta: { sessionState },
      })
      throw redirect({
        to: "/qr/$qrLookupID/passes/$epoch/redeem/$passID/redemption-complete",
        params: isRedemingPass.params,
      })
    }

    return { sessionState }
  },
  component: Outlet,
})
